<template>
  <v-card color="background" class="mx-5 pt-5" flat height="100%">
    <v-container fluid class="px-0">
      <v-row no-gutters>
        <v-col cols="12" sm="8" md="8">
          <v-card-title class="pt-0 pl-1 pb-2">
            {{ $t("views.createEntry.newEntry") }}
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 mb-12 pb-12 px-0">
      <v-form :disabled="loading" lazy-validation ref="manual-entry-form">
        <!-- <v-toolbar class="elevation-0">
            <v-btn icon @click="cancel()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{
              $t("views.createEntry.newEntry")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text @click.stop="showConfirmSaveDialog = true">
                {{ $t("views.createEntry.save") }}
              </v-btn>
            </v-toolbar-items>
          </v-toolbar> -->
        <v-container fluid class="pt-0 px-0">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" sm="8" md="8">
              <v-container class="pt-0">
                <v-dialog v-model="showConfirmSaveDialog">
                  <v-card>
                    <v-card-title class="text-h5">{{
                      $t("views.createEntry.readyToSave")
                    }}</v-card-title>

                    <v-card-text>
                      {{
                        $t(
                          "views.createEntry.onceSavedYourEntryCannotBeModifiedOrDeletedYouCanHoweverMarkItAsResolvedAndAddAdditionalNotes"
                        )
                      }}
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="darken-1"
                        text
                        @click="showConfirmSaveDialog = false"
                      >
                        {{ $t("views.createEntry.cancel") }}
                      </v-btn>

                      <v-btn color="red darken-1" text @click="save()">
                        {{ $t("views.createEntry.yesSave") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-container>

              <v-card :loading="loading">
                <v-container class="pt-6 px-6">
                  <v-dialog
                    ref="dateDialog"
                    v-model="resolveDateDialog"
                    :return-value.sync="resolveDate"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <!-- prepend-icon="mdi-calendar" -->
                      <v-text-field
                        v-model="resolveDate"
                        :label="$t('views.createEntry.dateOfService')"
                        readonly
                        v-on="on"
                        :rules="formResolveDateRules"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="resolveDate"
                      color="primary"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="resolveDateDialog = false"
                        >{{ $t("views.createEntry.cancel") }}</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dateDialog.save(resolveDate)"
                        >{{ $t("views.createEntry.ok") }}</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>

                  <div v-if="isAndroid">
                    <a @click="triggerNativeModal()">Trigger native modal</a>
                  </div>

                  <v-file-input
                    outlined
                    v-model="attachments"
                    :label="$t('views.createEntry.attachPhotosDocuments')"
                    clearable
                    multiple
                    show-size
                    chips
                    counter
                    required
                    prepend-icon=""
                  ></v-file-input>
                  <!-- prepend-icon="mdi-note" -->
                  <v-textarea
                    outlined
                    auto-grow
                    :rules="formNotesRules"
                    color="primary"
                    class="mt-4"
                    v-model="content"
                  >
                    <template v-slot:label>
                      {{
                        $t("views.createEntry.descriptionOfMaintenanceTasks")
                      }}
                    </template>
                  </v-textarea>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-container>
    <v-container fluid class="mt-12 px-0 pb-0 button--bottom">
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" sm="8" md="4">
          <v-btn
            @click.stop="showConfirmSaveDialog = true"
            block
            color="primary"
            class="button"
          >
            {{ $t("views.createEntry.save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import {
  createLogEntry,
  createLogNote,
  uploadFileResources,
} from "@/api/log-entries";

export default {
  name: "ServiceLog",
  components: {},
  data: () => ({
    showDatePicker: false,
    showConfirmSaveDialog: false,
    loading: false,
    attachments: [],
    content: [],
    status: "DONE",
    category: "Other",
    resolveDateDialog: false,
    resolveDate: null,
    // categories: [
    //   { text: "Regular service" },
    //   { text: "Irregular service" },
    //   { text: "Replacement" },
    //   { text: "Other" },
    // ],
    // formCategoryRules: [],
    formNotesRules: [],
    formResolveDateRules: [],
  }),
  created() {
    this.setInitialData();
  },
  methods: {
    setInitialData() {
      // this.formCategoryRules = [(v) => !!v || "Category is required"];
      this.formNotesRules = [
        (v) => !!v || this.$t("views.createEntry.messageIsRequired"),
        (v) =>
          (v && v.trim && v.trim().length > 3) ||
          this.$t("views.createEntry.messageIsTooShort"),
      ];
      this.formResolveDateRules = [
        (v) => !!v || this.$t("views.createEntry.dateIsRequired"),
      ];
    },
    cancel: function() {
      this.$router.push("/");
    },
    save: function() {
      if (!this.$refs["manual-entry-form"].validate()) {
        this.showConfirmSaveDialog = false;
        return;
      }

      this.showConfirmSaveDialog = false;
      this.loading = true;

      uploadFileResources(this.accessToken, this.attachments, this.userBoatId)
        .then((fileResources) => {
          return fileResources.map((x) => x.file_resource_uuid);
        })
        .then((fileResourceUUIDs) => {
          let entry = {
            title: this.category,
            status: this.status,
            completion_date: this.resolveDate + "T00:00",
          };
          return createLogEntry(this.accessToken, this.userBoatId, entry).then(
            (logEntry) => {
              return {
                logEntry: logEntry,
                fileResourceUUIDs: fileResourceUUIDs,
              };
            }
          );
          // .catch((error) => {
          //   console.error(error);
          //   this.loading = false;
          //   alert("Ooups, Something went wrong while saving your entry. \n" + JSON.stringify(error.non_field_errors));
          // });
        })
        .then((retObject) => {
          let note = {
            content: this.content,
            file_resource_uuids: retObject.fileResourceUUIDs,
          };
          return createLogNote(
            this.accessToken,
            this.userBoatId,
            retObject.logEntry.uuid,
            note
          );
          // .catch((error) => {
          //   console.error(error);
          //   this.loading = false;
          //   alert("Ooups, Something went wrong while saving your entry note.");
          // });
        })
        .then((logNote) => {
          this.$router.push("/");
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;

          let extra = "";
          if (error.non_field_errors) {
            extra = JSON.stringify(error.non_field_errors);
          }
          alert(
            this.$t(
              "views.createEntry.ooupsSomethingWentWrongSavingYourEntry"
            ) +
              "\n" +
              extra
          );
        });
    },
    triggerNativeModal: function() {
      window.Android.pickImageFromJavascript(123);
    },
  },
  computed: {
    ...mapState({
      accessToken: (s) => s.accessToken,
      userBoatId: (s) => s.userBoatId,
    }),
    isAndroid: function() {
      return (
        window.Android && window.Android.pickImageFromJavascript !== undefined
      );
    },
    pickVal: function() {
      if (window.Android && window.Android.pickImageFromJavascript) {
        return window.Android.pickImageFromJavascript.toString();
      } else {
        return "";
      }
    },
    androidVal: function() {
      if (window.Android) {
        return JSON.stringify(window.Android);
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped>
.headline--title {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: black;
}

.button--bottom {
  position: absolute;
  width: 100%;
  bottom: 40px;
}
</style>
